// extracted by mini-css-extract-plugin
export default {"month":"Month_month__MviYi"};